<template>
  <MTableCell
    class="m-table-cell-combined-control"
    :class="{'m-table-cell-dropdown-trigger_disabled': disableNestTrigger}"
  >
    <div class="m-table-cell-combined-control__checkbox-container">
      <MCheckbox
        v-if="showCheckbox"
        :value="rowIsSelected"
        :disabled="disableCheckbox"
        @input="handleSelect"
      />
    </div>

    <div
      v-if="visibleNestArrow"
      class="m-table-cell-combined-control__dropdown-container"
      @click="handleExpandNested"
    >
      <div class="m-table-cell-dropdown-trigger__button">
        <MIcon
          :icon="iconArrowDown"
          class="m-table-cell-dropdown-trigger__state-icon"
          :class="{
            'm-table-cell-dropdown-trigger__state-icon_opened': nestedTableOpened,
            'm-table-cell-dropdown-trigger_disabled': disableNestTrigger
          }"
        />
      </div>
    </div>

    <div
      v-if="showHint"
      class="m-table-cell-combined-control__notification-container"
    >
      <div
        class="m-table-cell-combined-control-hint"
      >
        <MIcon :icon="warningSignIcon" />
      </div>
    </div>
  </MTableCell>
</template>

<script>
  import MCheckbox from 'components/Inputs/Basic/MCheckbox';
  import iconArrowDown from 'assets/icons/outline-arrow-down.svg';
  import MIcon from 'components/Design/MIcon';
  import warningSignIcon from 'assets/icons/warningSign.svg';
  import MTableCell from 'components/Data/Tables/MTable/cells/MTableCell';

  export default {
    name: 'MTableCellCombinedControl',
    components: {MTableCell, MCheckbox, MIcon},
    props: {
      tableRow: {
        type: Object,
        required: true
      },
      openedNestedRows: {
        type: Array,
        default: Array
      },
      uniqueKeyAttr: {
        type: String,
        default: 'id'
      },
      selectedIdsSet: {
        type: Set,
        required: true
      },
      selectedIds: {
        type: Array,
        required: true
      },
      showHintPredicate: {
        type: Function,
        default: () => false
      },
      index: {
        type: Number,
        required: true
      },
      withSummaryRow: {
        type: Boolean,
        default: false
      },
      isAllSelected: {
        type: Boolean,
        default: false
      },
      isAllNestedOpened: {
        type: Boolean,
        default: false
      },
      visibleNestArrow: {
        type: Boolean,
        default: true
      },
      disableNestPredicate: {
        type: Function,
        default: () => false
      },
      disableCheckboxPredicate: {
        type: Function,
        default: () => false
      },
      showCheckboxPredicate: {
        type: Function,
        default: () => true
      }
    },
    data () {
      return {
        iconArrowDown,
        warningSignIcon
      };
    },
    computed: {
      nestedTableOpened () {
        if (this.isGlobalControl) {
          return this.isAllNestedOpened;
        }
        return this.openedNestedRows.includes(this.tableRow[this.uniqueKeyAttr]);
      },
      dropdownEnabled () {
        return true;
      },
      isGlobalControl () {
        return this.withSummaryRow && this.index === 0;
      },
      rowIsSelected () {
        if (this.isGlobalControl) {
          return this.isAllSelected;
        }
        return this.selectedIdsSet.has(this.tableRow[this.uniqueKeyAttr]);
      },
      showHint () {
        return this.showHintPredicate(this.tableRow);
      },
      disableNestTrigger () {
        return this.disableNestPredicate(this.tableRow);
      },
      disableCheckbox () {
        return this.disableCheckboxPredicate(this.tableRow);
      },
      showCheckbox () {
        return this.showCheckboxPredicate(this.tableRow);
      }
    },
    methods: {
      handleSelect (val) {
        if (this.isGlobalControl) {
          return this.$emit('triggerSelectAll', !this.rowIsSelected);
        }
        this.$emit('triggerSelect', {
          [this.uniqueKeyAttr]: this.tableRow[this.uniqueKeyAttr],
          value: val
        });
      },
      handleExpandNested () {
        if (this.disableNestTrigger) {
          return;
        }

        if (this.isGlobalControl) {
          return this.$emit('triggerNestedAll', true);
        }
        this.$emit('triggerNested', this.tableRow);
      }
    }
  };
</script>

<style>
  .m-table-cell-combined-control {
    display: flex;
    align-items: center;
  }

  .m-table-cell-combined-control__checkbox-container .m-checkbox__check-mark {
    margin-right: 0;
  }

  .m-table-cell-combined-control__dropdown-container {
    cursor: pointer;

    margin-left: 2px;
    user-select: none;
  }

  .m-table-cell-combined-control__notification-container {
    flex-grow: 0;
    flex-shrink: 0;

    width: 16px;
    height: 16px;

    margin-left: 4px;
  }

  .m-table-cell-combined-control-hint {
    color: var(--warning-color);
  }

</style>
